// extracted by mini-css-extract-plugin
module.exports = {"link":"link___1NNx6","is-underlined":"is-underlined___3mcsM"};